export default __webpack_public_path__ + "static/data_port_w.eb4bafc032aec625d89136c340b68af0.svg";